export const releaseNotesData = {
  releaseNotes: [
    {
      version: "1.0.0",
      date: "2024-03-20",
      "Feature List": {
        Patient: ["Signup with Careadmin feature introduced."],
        Doctor: ["Fixed hospital icon visibility issue."],
        "Care Admin": ["Enhanced performance for loading times."],
      },
    },
    {
      version: "2.0.0",
      date: "2024-03-20T10:40:00",
      "Bug Fixes": [
        "Fixed the Hospital icon in the banner (Dashboard)",
        "Footer-Healthcare removed.",
        "Schedule Appointment letter case is changed",
        "General consultation Fee plan name is changed",
        "The scrollbar in the modal in doctor video consultation is changed",
        "Patient record form in offline patient registration alignment is changed",
      ],
      "Feature List": [
        "Signup with Careadmin",
        "Signup individual /dependent account",
        "View account holder details",
        "Proceed to payment and plan activation",
      ],
    },
    {
      version: "3.0.0",
      date: "2024-03-20T17:25:00",
      "Bug Fixes": [
        "Alternative slots are enabled for Dr Neeraj. But if I click, it is showing not available.",
        "Change the Hospital visit icon in Dr login. Currently displaying video icon.",
        "Text change - Please upgrade or extend your plan to schedule an appointment",
        "Instead of fixing - pls use scheduling text wherever applicable.",
        "Display the correct message in Activate plan - Careadmin: offline Patient Registration.",
      ],
    },
    {
      version: "4.0.0",
      date: "2024-03-21T17:58:00",
      "Bug Fixes": [
        "Replace the parental consent form with the new one",
        "In Doctor Role My Patient Module Physical Health Complaints Details Text aligned improperly",
        "Can u align the Care receiver and consistently activate plan details.",
        "Pls add the Rupees symbol in Plan",
        "All Dr's listed if I change the slot using Alternative slots",
        "Any possibility of removing the Video from the Video consultation card.",
        "Banner change from Video consultation to Hospital visit.",
      ],
    },
  ],
};
